import { render, staticRenderFns } from "./bottomSheet.vue?vue&type=template&id=636032c0&scoped=true&"
import script from "./bottomSheet.vue?vue&type=script&lang=js&"
export * from "./bottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./bottomSheet.vue?vue&type=style&index=0&id=636032c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636032c0",
  null
  
)

export default component.exports